import { render, staticRenderFns } from "./BarChartTwo.vue?vue&type=template&id=32a4ad04"
import script from "./BarChartTwo.vue?vue&type=script&lang=js"
export * from "./BarChartTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports